export var CohortFeatureOperationEnum;
(function (CohortFeatureOperationEnum) {
    CohortFeatureOperationEnum["eq"] = "=";
    CohortFeatureOperationEnum["ne"] = "!=";
    CohortFeatureOperationEnum["gt"] = ">";
    CohortFeatureOperationEnum["gte"] = ">=";
    CohortFeatureOperationEnum["lt"] = "<";
    CohortFeatureOperationEnum["lte"] = "<=";
    CohortFeatureOperationEnum["in"] = "in";
    CohortFeatureOperationEnum["nin"] = "not in";
    CohortFeatureOperationEnum["between"] = "between";
})(CohortFeatureOperationEnum || (CohortFeatureOperationEnum = {}));
//# sourceMappingURL=CohortFeatureOperationEnum.js.map